document.addEventListener('DOMContentLoaded', () => {

  function offset(el) {
    const rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
  }

  function scrollToElement(target) {
    const header = document.querySelector('.t3m-Header.t3m-Header--main');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const scrollHeight = offset(target).top;
    const scrollToPosition = 2 * headerHeight + scrollHeight;
    if (scrollToPosition < document.documentElement.scrollTop) {
      scrollTo(scrollHeight - 2 * headerHeight, 1000);
    }
    let offsetPosition = scrollHeight - headerHeight - 16;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  // Function to scroll up on page click
  function scrollUp() {
    scrollToElement(document.querySelector('[data-adv-stage="result-list"]'));
  }

  Handlebars.registerHelper('ifeq', function (a, b, options) {
    if (a == b) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  const hashPrefix = 'adv';
  const prefix = hashPrefix + '-';

  // handler for holding and updating request data
  // (constant parameters and filter data)
  function RequestDataHandler() {
    this.data = {
      type: '1524497830',
      tx_leicaacademy_page: {
        // extbase
        controller: 'PageRequest',
        action: 'list',
        format: 'json',
        filters: {},
        overwriteConf: {}

          // actual data, set by the filters within in the dom
        // 'pageTypes': '',
        // 'topicIds': '',
        // 'tagIds': '',
        // 'status': '0',
        // 'currentPage': '1'
      }
    };
    if (window.academy && window.academy.page.list.conf) {
      this.data.tx_leicaacademy_page.overwriteConf = window.academy.page.list.conf;
      this.data.tx_leicaacademy_page.limit = window.academy.page.list.conf.limit;
    }

    this.updateFilterData = function (filters) {
      let changedFilters = false;
      let changedPager = false;
      const controlParameters = {
        controller: true,
        action: true,
        format: true,
        filters: true,
        overwriteConf: true
      };
      const filtersFound = {};
      let key;

      for (key in filters) {
        filtersFound[key] = true;
        if (key === 'currentPage') {
        if (this.data.tx_leicaacademy_page[key] !== filters[key]) {
            changedPager = true;
            this.data.tx_leicaacademy_page[key] = filters[key];
          }
          } else {
          if (this.data.tx_leicaacademy_page['filters'][key] !== filters[key]) {
            changedFilters = true;
            this.data.tx_leicaacademy_page['filters'][key] = filters[key];
          }
        }
      }

      // remove filter parameters which are absent in the current dom
      // they should not be sent at all, not even as empty parameter
      // because they could overwrite actual URL parameters of the current page
      for (key in this.data.tx_leicaacademy_page) {
        if (!controlParameters[key] && !filtersFound[key]) {
          if (this.data.tx_leicaacademy_page[key]) {
            // if such a parameter had a non-empty value
            // we consider the request data to have changed
            if (key === 'currentPage') {
              if (this.data.tx_leicaacademy_page[key] !== '1') {
                changedPager = true;
              }
            } else {
              changedFilters = true;
            }
          }
          delete this.data.tx_leicaacademy_page[key];
        }
      }

      // reset pager if filters have changed
      if (changedFilters) {
        this.data.tx_leicaacademy_page['currentPage'] = '1';
      }

      return changedPager || changedFilters;
    };
  }

  // interface handler
  // triggers event 'filter-changed' (with prefix)
  // when the user interacts with any filters (including the pager)
  function FilterUi() {

    this.isDefaultFilter = function(filterData) {
      if (!filterData) {
        return true;
      }
      for (let key in filterData) {
        if (!filterData.hasOwnProperty(key)) {
          continue;
        }
        if (key !== 'currentPage') {
          return false;
        }
        if (filterData[key] !== '1') {
          return false;
        }
      }
      return true;
    };

    this.getAllFilters = function () {
      const filters = {};
      document.querySelectorAll('[data-' + prefix + 'filter]').forEach(filter => {
        const key = filter.dataset[hashPrefix + 'Filter'];
        if (!filters[key]) {
          filters[key] = this.getFilterValue(key);
        }
      });
      if (!filters['currentPage']) {
        filters['currentPage'] = '1';
      }
      return filters;
    };

    this.getFilterValue = function (key) {
      const result = [];
      const found = {};
      document.querySelectorAll('[data-' + prefix + 'filter="' + key + '"].active').forEach(filter => {
        const value = filter.dataset[hashPrefix + 'Value'];
        if (!found[value]) {
          found[value] = true;
          result.push(value);
        }
      });
      return result.join(',');
    };

    this.setAllFilters = function (filterData, dontTriggerReload) {
      for (let key in filterData) {
        this.setFilterValue(key, filterData[key], true);
      }
      if (!dontTriggerReload) {
        document.dispatchEvent(new Event(prefix + 'filter-changed'));
      }
    };

    this.setFilterValue = function (key, value, dontTriggerReload) {
      const allFilters = [...document.querySelectorAll('[data-' + prefix + 'filter="' + key + '"]')];
      const defaultFilters = [];
      const allFiltersButDefault = [];
      allFilters.forEach(filter => {
        if (filter.dataset[hashPrefix + 'Role'] === 'default') {
          defaultFilters.push(filter);
        } else {
          allFiltersButDefault.push(filter);
        }
      });

      if (!value) {
        allFiltersButDefault.forEach(filter => { filter.classList.remove('active'); });
        defaultFilters.forEach(filter => { filter.classList.add('active'); });
      } else {
        const values = value.split(',');
        allFilters.forEach(filter => { filter.classList.remove('active'); });
        for (let i in values) {
          allFilters.forEach(filter => {
            if (filter.dataset[hashPrefix + 'Value'] === values[i]) {
              filter.classList.add('active');
              if (!dontTriggerReload) {
                filter.dispatchEvent(new Event(prefix + 'filter-changed', { bubbles: true }));
              }
            }
          });
        }
      }
    };

    this.setIndicator = function (key) {
      document.querySelectorAll('[data-' + prefix + 'indicator*="' + key + '"]').forEach(indicator => {
        indicator.classList.add(key);
      });
    };

    this.unsetIndicator = function (key) {
      document.querySelectorAll('[data-' + prefix + 'indicator*="' + key + '"]').forEach(indicator => {
        indicator.classList.remove(key);
      });
    };

    this.filterClicked = function(filter) {
      const key = filter.dataset[hashPrefix + 'Filter'];
      const type = filter.dataset[hashPrefix + 'Type'] || 'multi';
      const value = filter.dataset[hashPrefix + 'Value'];
      const allFilters = [...document.querySelectorAll('[data-' + prefix + 'filter="' + key + '"]')];
      const defaultFilters = [];
      const allFiltersButDefault = [];
      allFilters.forEach(filter => {
        if (filter.dataset[hashPrefix + 'Role'] === 'default') {
          defaultFilters.push(filter);
        } else {
          allFiltersButDefault.push(filter);
        }
      });

      // there may be multiple buttons for the same filter, now we synchronize them
      const filters = [...document.querySelectorAll('[data-' + prefix + 'filter="' + key + '"][data-' + prefix + 'value="' + value + '"]')];
      // if at least one filter button is active, the filter is considered active
      const filtersActive = filters.filter(filter => filter.classList.contains('active')).length > 0;
      filters.forEach(filter => {
        filter.classList[filtersActive ? 'add' : 'remove']('active');
      });

      if (type === 'radio') {
        allFilters.forEach(filter => { filter.classList.remove('active'); });
      } else { // type === 'multi'
        if (defaultFilters.length > 0) {
          if (filter.dataset[hashPrefix + 'Role'] === 'default') {
            // if default filter is clicked, deactivate all other filters
            allFilters.forEach(filter => { filter.classList.remove('active'); });
          } else {
            // else decativate the default filter
            defaultFilters.forEach(filter => { filter.classList.remove('active'); });
          }
        }
      }

      filters.forEach(filter => { filter.classList.toggle('active'); });

      if (type === 'multi') {
        if (defaultFilters.length > 0) {
          // if no filters active or if all filters are avtive
          // then decativate all filters an activate the default filter
          const filterCount = allFiltersButDefault.length;
          const activeFilterCount = allFiltersButDefault.filter(filter => filter.classList.contains('active')).length;
          if (activeFilterCount === 0 || activeFilterCount === filterCount) {
            allFiltersButDefault.forEach(filter => { filter.classList.remove('active'); });
            defaultFilters.forEach(filter => { filter.classList.add('active'); });
          }
        }
      } // else type === 'radio'

      filters.forEach(filter => {
        filter.dispatchEvent(new Event(prefix + 'filter-changed', { bubbles: true }));
      });
    }

    this.registerFilterEvents = function () {
      document.addEventListener('click', e => {
        const target = e.target.closest('[data-' + prefix + 'filter]');
        if (target) {
          e.preventDefault();
          this.filterClicked(target);
        }
      });
    };
  }

  // result list renderer
  // triggers 'new-markup' (with prefix)
  // when a container got newly rendered markup (to re-register for dom events)
  function ResultRenderer() {
    const templates = [];
    document.querySelectorAll('[data-' + prefix + 'template]').forEach(templateContainer => {
      const key = templateContainer.dataset[hashPrefix + 'Template'];
      let stageContainer = document.querySelector('[data-' + prefix + 'stage="' + key + '"]');
      if (stageContainer === null) {
        stageContainer = templateContainer;
      }
      const templateMarkup = templateContainer.querySelector('script').innerHTML;
      const template = Handlebars.compile(templateMarkup);
      templates.push(context => {
        const markup = template(context);
        stageContainer.innerHTML = markup;
        stageContainer.style.display = '';
        stageContainer.dispatchEvent(new Event(prefix + 'new-markup', { bubbles: true }));
      });
      if (templateContainer !== stageContainer) {
        templateContainer.remove();
      }
    });

    this.render = function (resultData) {
      const context = {
        pages: resultData.pages,
        showPager: false,
        pagerSize: 4,
        pagerItems: []
      };
      let i;

      // showing a max size of 10 items
      if (resultData.pageCount > 1 && context.pagerSize >= resultData.pageCount) {
        context.showPager = true;
        for (i = 1; i <= resultData.pageCount; i++) {
          context.pagerItems.push({isDivider: false, isCurrent: i === resultData.currentPage, index: i, number: i});
        }
      } else if (context.pagerSize < resultData.pageCount) {
        context.showPager = true;
        let dividerHelper = true;

        context.pageCount = resultData.pageCount;
        if (resultData.currentPage > 1) {
          context.prevPage = resultData.currentPage - 1;
        }
        if (resultData.pageCount > resultData.currentPage) {
          context.nextPage = resultData.currentPage + 1;
        }
        for (i = 1; i <= resultData.pageCount; i++) {
          if (i < resultData.currentPage + context.pagerSize && i > resultData.currentPage - context.pagerSize) {
            // within size range
            context.pagerItems.push({isDivider: false, isCurrent: i === resultData.currentPage, index: i, number: i});
            dividerHelper = true;
          } else if (
            (resultData.currentPage - context.pagerSize >= i && dividerHelper) ||
            (resultData.currentPage + context.pagerSize <= i && dividerHelper)
          ) {
            // add divider
            dividerHelper = false;
            context.pagerItems.push({isDivider: true, isCurrent: false, index: i, number: i});
          }
        }
      }
      for (i = 0; i < templates.length; i++) {
        templates[i](context);
      }
    };
  }

  // handler for ajax requests
  function Api() {
    let currentRequest = null;

    this.abortRequest = function () {
      if (currentRequest !== null) {
        currentRequest.abort();
        currentRequest = null;
      }
    };

    this.fetchResults = function (requestData, cb) {
      // abort old request if necessary
      this.abortRequest();

      // build url
      function getParameters(data, prefix) {
        const parameters = [];
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            const value = data[key];
            if (typeof value === 'object') {
              if (prefix === undefined) {
                parameters.push(...getParameters(value, key));
              } else {
                parameters.push(...getParameters(value, prefix + '[' + key + ']'));
              }
            } else {
              if (prefix === undefined) {
                parameters.push(key + '=' + encodeURIComponent(value));
              } else {
                parameters.push(prefix + '[' + key + ']=' + encodeURIComponent(value))
              }
            }
          }
        }
        return parameters;
      }
      let url = requestData.tx_leicaacademy_page.overwriteConf.ajaxUrl;
      const parameters = getParameters(requestData);
      url += (url.indexOf('?') > -1 ? '&' : '?') + parameters.join('&');

      // build new request
      currentRequest = new window.XMLHttpRequest();
      currentRequest.open('GET', url, true);
      currentRequest.onload = function () {
        currentRequest = null;
        if (this.status >= 200 && this.status < 400) {
          cb(JSON.parse(this.responseText));
        } else {
          cb(false);
        }
      };
      currentRequest.onerror = function () {
        currentRequest = null;
        cb(false);
      };

      // send request
      currentRequest.send();
    };
  }

  // handler for en- and decoding filter data
  function HashHandler() {

    const shorthands = {
      currentPage: 'p',
      topicIds: 't',
      pageTypes: 'y',
      tagIds: 'a',
      status: 's'
    };
    const decodeShorthands = {};
    for (let i in shorthands) {
      decodeShorthands[shorthands[i]] = i;
    }

    this.encode = function (filterData) {
      let hash = '/' + hashPrefix + '/';
      const hashParts = [];
      for (let key in filterData) {
        if (filterData[key] && filterData[key] != 0) {
          hashParts.push(shorthands[key] + ',' + filterData[key]);
        }
      }
      if (hashParts.length === 0) {
        return '';
      }
      hash += hashParts.join('/');
      return hash;
    };

    this.decode = function (hash) {
      hash = hash.replace('#', '');
      if (hash.substr(0, hashPrefix.length + 2) !== '/' + hashPrefix + '/') {
        return false;
      }
      const filterData = {};
      hash = hash.substr(hashPrefix.length + 2);
      const hashParts = hash.split('/');
      for (let i in hashParts) {
        const hashPart = hashParts[i];
        const filterParts = hashPart.split(',');
        const key = filterParts.shift();
        const value = filterParts.join(',');
        filterData[decodeShorthands[key]] = value;
      }
      return filterData;
    };
  }

  const hashHandler = new HashHandler();
  const requestDataHandler = new RequestDataHandler();
  const api = new Api();
  const filterUi = new FilterUi();
  const resultRenderer = new ResultRenderer();

  // fetch all filter data from ui
  // optionally update the browser url hash
  // update the request data
  // return whether or not the request data has actually changed
  function updateRequestData(dontUpdateHash) {
    const filterData = filterUi.getAllFilters();

    // in most cases this won't do anything,
    // but it will synchronize newly rendered filters if there are any
    filterUi.setAllFilters(filterData, true);

    if (!dontUpdateHash) {
      const hash = hashHandler.encode(filterData);
      if (hash || !history || !history.pushState) {
        window.location.hash = hash;
      } else {
        history.pushState('', document.title, location.pathname + location.search);
      }
    }
    return requestDataHandler.updateFilterData(filterData);
  }

  // fetch request data from ui initially, do not trigger reloading the results, do not update the hash
  updateRequestData(true);
  filterUi.registerFilterEvents();

  // for newly built markup, re-register for dom events
  // also re-fetch request data from ui without triggering reloading the results
  // and update the hash value
  document.addEventListener(prefix + 'new-markup', updateRequestData);

  // when a filter/pager is changed, reload the result list
  let apiCallTimeout;
  document.addEventListener(prefix + 'filter-changed', () => {
    // update request data
    const requestDataChanged = updateRequestData();
    // see if the ui change did actually cause a change in the request data
    if (requestDataChanged) {
      // abort ongoing request
      api.abortRequest();

      filterUi.unsetIndicator('error');
      filterUi.unsetIndicator('empty');
      filterUi.setIndicator('loading');
      // Prevent sending multiple requests in very short time
      clearTimeout(apiCallTimeout);
      // Wait 2 seconds after last click before initiating ajax call
      apiCallTimeout = setTimeout(() => {
        // request new results
        api.fetchResults(requestDataHandler.data, (resultData) => {
          // handle response
          filterUi.unsetIndicator('loading');
          if (resultData) {
            if (!resultData.pages || resultData.pages.length === 0) {
              filterUi.setIndicator('empty');
            }
            resultRenderer.render(resultData);

            // trigger event for filter update success
            document.dispatchEvent(new CustomEvent(prefix + 'filter-complete', {
              detail: {
                filters: filterUi.getAllFilters(),
                status: 'success'
              }
            }));
          } else {
            filterUi.setIndicator('error');
          }
        });
      }, 2000);
    }
  });

  // check for hash filter data
  const filterData = hashHandler.decode(window.location.hash);
  if (!filterUi.isDefaultFilter(filterData)) {
    filterUi.setAllFilters(filterData);
    scrollUp();
  }
});
